// ============================================================================
// MASTER OPTIONS ENDPOINTS
// ============================================================================

import { buildEndpointWithParams } from './base.endpoints';

export const MASTER_OPTIONS_BASE_PATH = '/MasterOptions';

export const masterOptionsEndpoints = {
  /** GET /api/v1/MasterOptions/{masterCode}?filter=… */
  get: (masterCode: string, filter?: string) => {
    const base = buildEndpointWithParams(`${MASTER_OPTIONS_BASE_PATH}/:masterCode`, { masterCode });
    return filter ? `${base}?filter=${encodeURIComponent(filter)}` : base;
  },
} as const;
